import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Match the restrictions banner: Label defaults to display: flex, which collapses the whitespace
  // after the inline <strong>Policy comments:</strong> (a documented Label gotcha). display: block
  // restores inline flow; pre-wrap keeps the source line breaks in multi-line comment text.
  text: {
    display: 'block',
    whiteSpace: 'pre-wrap',
    padding: theme.spacing(1, 0)
  }
}));

export default useStyles;
